/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Whole_PeriodInputs */



/**
* | output |
* | --- |
* | "whole period" |
*
* @param {Receipt_Whole_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_whole_period = /** @type {((inputs?: Receipt_Whole_PeriodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Whole_PeriodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("ganzer Zeitraum")
	return /** @type {LocalizedString} */ ("whole period")
});